import { parseCurrency } from '@helper/parseCurrency'

export const parseSalesKpiDataModal = (data: any[]): any[] => {
  const formattedValue = (value: number) => {
    return value.toFixed(2)
  }

  return data.map(item => {
    return {
      'periodo-id': item.periodo ? item.periodo : '',

      'venda-liquida-lastYear-id': item.receitaLiquidaAnoAnteriorRS
        ? parseCurrency({
            value: item.receitaLiquidaAnoAnteriorRS,
            country: 'pt-br'
          })
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'venda-liquida-currentYear-id': item.receitaLiquidaAnoAtualRS
        ? parseCurrency({
            value: item.receitaLiquidaAnoAtualRS,
            country: 'pt-br'
          })
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'porcentagem-venda-liquida-id': item.receitaLiquidaPercentualRS
        ? formattedValue(item.receitaLiquidaPercentualRS)
        : 0,

      'venda-liquida-btleo-lastYear-id': item.receitaLiquidaAnoAnteriorBT
        ? parseCurrency({
            value: item.receitaLiquidaAnoAnteriorBT,
            country: 'pt-br'
          })
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'venda-liquida-btleo-currentYear-id': item.receitaLiquidaAnoAtualBT
        ? parseCurrency({
            value: item.receitaLiquidaAnoAtualBT,
            country: 'pt-br'
          })
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-venda-liquida-btleo-id': item.receitaLiquidaPercentualBT
        ? formattedValue(item.receitaLiquidaPercentualBT)
        : 0,

      'margem-lastYear-id': item.margemLiquidaAnoAnterior
        ? parseCurrency({
            value: item.margemLiquidaAnoAnterior,
            country: 'pt-br'
          })
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'margem-currentYear-id': item.margemLiquidaAnoAtual
        ? parseCurrency({
            value: item.margemLiquidaAnoAtual,
            country: 'pt-br'
          })
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-margem-id': item.margemLiquidaPercentual
        ? formattedValue(item.margemLiquidaPercentual)
        : 0,

      'porcentagem-margem-lastYear-id': item.margemAnoAnterior
        ? formattedValue(item.margemAnoAnterior)
        : 0,
      'porcentagem-margem-currentYear-id': item.margemAnoAtual
        ? formattedValue(item.margemAnoAtual)
        : 0,
      'valor-porcentagem-margem-id': item.margemPercentual
        ? formattedValue(item.margemPercentual)
        : 0,
      'subcategoria-codigo-id': item.subCategoriaId ? item.subCategoriaId : 0,
      'subcategoria-nome-id': item.subCategoriaDescricao
        ? item.subCategoriaDescricao
        : ''
    }
  })
}
